import { logError } from "common/error";
import { Waiter } from "common/promises";
import { paths } from "from-start/scene/resources";
import { html, LitElement } from "lit-element";
import { nothing } from "lit-html";
import { styleMap } from "lit-html/directives/style-map";
import log from "loglevel";
import { WatchVideoPlaying } from "./watchVideoPlaying";
/**
 * announceClick event 발생
 */
export class Announce extends LitElement {
    constructor() {
        super();
        this.buttonState = "waitingPermission";
        this.buttonEnable = true;
        if (DeviceOrientationEvent == null ||
            typeof DeviceOrientationEvent.requestPermission !== "function") {
            this.buttonState = "waitingStart";
        }
    }
    createRenderRoot() {
        return this;
    }
    render() {
        const buttonParentStyle = {
            top: "0",
            left: "0",
            bottom: "0",
            right: "0",
            width: "720px",
            height: "1388px",
            margin: "auto",
            position: "absolute",
        };
        const buttonStyle = {
            top: "840px",
            left: "157px",
            width: "410px",
            height: "200px",
            position: "absolute",
            background: "none",
            border: "none",
        };
        let button;
        switch (this.buttonState) {
            case "waitingPermission":
                button = html `<img
          class="absolute"
          src=${paths.video360NoticePermission}
        />`;
                break;
            case "waitingStart":
                button = html `<img
          class="absolute"
          src=${paths.video360NoticeStart}
        />`;
                break;
            case "done":
                button = nothing;
                break;
        }
        return html `<img
        class="absolute-center top-0"
        src="${paths.video360Notice}"
      />
      ${button}
      <div style="${styleMap(buttonParentStyle)}" id="360-announce-parent">
        <button
          class="pointer-allow"
          style="${styleMap(buttonStyle)}"
          @click="${this.handleButtonClick}"
        ></button>
      </div>`;
    }
    async handleButtonClick() {
        if (!this.buttonEnable) {
            log.warn("announce button clicked but it is disabled now");
            return;
        }
        this.buttonEnable = false;
        try {
            switch (this.buttonState) {
                case "waitingPermission":
                    await this.handlePermissionButtonClick();
                    break;
                case "waitingStart":
                    await this.handlePlayButtonClick();
                    break;
                case "done":
                    log.warn("announce button clicked but is done state");
                    break;
            }
            log.debug("announce button clicked");
        }
        catch (e) {
            logError(e);
        }
        finally {
            this.buttonEnable = true;
        }
    }
    async handlePermissionButtonClick() {
        const waiter = new Waiter();
        if (typeof DeviceOrientationEvent.requestPermission === "function") {
            DeviceOrientationEvent.requestPermission()
                .then(() => {
                log.debug("orientation permission acquired");
                waiter.trigger();
            })
                .catch(() => {
                log.error("Cannot get orientation permission");
                waiter.trigger();
            });
            // iOS 13+
        }
        else {
            log.error("No device motion event");
            waiter.trigger();
            // non iOS 13+
        }
        waiter.wait();
        this.buttonState = "waitingStart";
        this.requestUpdate();
    }
    async handlePlayButtonClick() {
        const video = $("a-videosphere")[0].components
            .material.material.map.image;
        await video.play();
        const watcher = new WatchVideoPlaying(video);
        watcher.watch();
        document.querySelector("a-scene").emit("deviceorientationpermissiongranted");
        $(this).addClass("dn");
        this.dispatchEvent(new CustomEvent("announceClick"));
        this.buttonState = "done";
        this.requestUpdate();
    }
}
customElements.define("jh-360-video-announce", Announce);
//# sourceMappingURL=announce.js.map